export const getDailyBatchHistInitialised = state => state.dailyBatchHist.initialisedDailyBatchHist;

export const getDefaultFilters = state => state.dailyBatchHist.defaultFilters;

export const getFilterDefinitions = state => state.dailyBatchHist.filterDefinitions;
export const getDailyBatchHistLastUpdated = state => state.dailyBatchHist.lastUpdatedDailyBatchHist;
export const getLoading = state => state.dailyBatchHist.dailyBatchHistLoading;
export const getRows = state => state.dailyBatchHist.rows;
export const getDefaultSort = state => state.dailyBatchHist.gridSorting;

export const getCurrentServerFilters = state => state.dailyBatchHist.currentServerFilters;

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'businessDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};
export const getSelectedRunId = state => state.dailyBatchHist.selectedRunId;
export const getRunDetail = state => state.dailyBatchHist.runDetail;
export const getLoadingRunDetail = state => state.dailyBatchHist.loadingRunDetail;

export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'businessDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};